import {useState, useEffect} from 'react'
import {TableRow} from '~/design-system/foundations'
import {
  type HgPricingTableRowContent,
  type HgPricingTableRowFeatureCell,
  type HgPricingTableRowContentCell,
} from '../types'
import HgPricingTableCell from './PricingTableCell'
import {type ComparisonSelection} from '~/design-system/hg/components/HgTable/types'

type HgPricingTableRowProps = {
  row: HgPricingTableRowContent
  selectedPlans: ComparisonSelection
  isNotMobile: boolean
  planOptions: Array<{value: string; label: string}>
}

export const HgPricingTableRow: React.FC<HgPricingTableRowProps> = ({
  row,
  selectedPlans,
  isNotMobile,
  planOptions,
}) => {
  const [visibleCells, setVisibleCells] = useState<HgPricingTableRowContent>(row)

  useEffect(() => {
    const getPlanIndex = (planId: string | null): number | null => {
      if (!planId) return null
      const index = planOptions.findIndex(option => option.value === planId)
      return index === -1 ? null : index + 1
    }

    const getVisibleRowCells = (
      row: HgPricingTableRowContent
    ): HgPricingTableRowContent => {
      if (isNotMobile) return row
      const rowTitleCell: HgPricingTableRowFeatureCell = row[0]
      const selectedIndices = [
        selectedPlans.primaryComparison,
        selectedPlans.secondaryComparison,
      ]
        .map(getPlanIndex)
        .filter((index): index is number => index !== null)
      const planCells: HgPricingTableRowContentCell[] = selectedIndices.map(
        index => row[index]
      )
      return [rowTitleCell, ...planCells]
    }

    setVisibleCells(getVisibleRowCells(row))
  }, [row, selectedPlans, isNotMobile, planOptions])

  return (
    <TableRow className="grid w-full grid-cols-2 gap-s4 pb-s6 pt-s3 md:grid-flow-col md:grid-cols-[repeat(4,minmax(150px,1fr))] md:p-0">
      {visibleCells.map((cell, columnIndex) => (
        <HgPricingTableCell
          variant={columnIndex === 0 ? 'rowTitle' : 'bodyRow'}
          cell={cell}
          key={columnIndex}
          oneColumn={!selectedPlans.secondaryComparison}
        />
      ))}
    </TableRow>
  )
}
